<template>
    <post-list apiUrl="CATEGORY" />
</template>


<script>
import PostList from './PostList.vue';
export default {
    components: {
        PostList
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/Categories.vue?6f43d8f6